export default function isEmptyString(text: string | null | undefined): boolean {
  return text === null || text === undefined || text.trim() === '';
}
